import { API } from "../admin/calendar/calendarUtils";

const b64ToUint8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export const iosVersion = () => {
  const m = navigator.userAgent.match(/OS (\d+)_(\d+)/);
  return isIOS() && m ? Number(m[1]) + Number(m[2]) / 100 : null;
};
export const permissionState = () => ("Notification" in window ? Notification.permission : "unsupported");

export async function checkRegistered(token, sub) {
  if (!sub) return false;
  const r = await fetch(`${API}/app/admin/push/check`, { method: "POST", headers: { "Content-Type": "application/json", "X-Admin-Token": token }, body: JSON.stringify({ endpoint: sub.endpoint }) });
  return r.ok && (await r.json()).registered;
}

export async function registerSW() {
  if (!("serviceWorker" in navigator)) return null;
  return navigator.serviceWorker.register("/app-sw.js", { scope: "/app" });
}

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/app");
  return reg ? reg.pushManager.getSubscription() : null;
}

export async function enablePush(token) {
  if (!pushSupported()) throw new Error(isIOS() && !isStandalone() ? "Auf dem iPhone bitte zuerst die App zum Home-Bildschirm hinzufügen und von dort öffnen." : "Dieses Gerät/dieser Browser unterstützt keine Push-Benachrichtigungen.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Benachrichtigungen wurden nicht erlaubt. Anleitung zum Freigeben siehe unten.");
  const reg = (await navigator.serviceWorker.getRegistration("/app")) || (await registerSW());
  await navigator.serviceWorker.ready;
  const { public_key } = await (await fetch(`${API}/app/push/public-key`)).json();
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(public_key) }));
  const res = await fetch(`${API}/app/admin/push/subscribe`, {
    method: "POST", headers: { "Content-Type": "application/json", "X-Admin-Token": token },
    body: JSON.stringify({ subscription: sub.toJSON(), device: navigator.userAgent.slice(0, 180) }),
  });
  if (!res.ok) throw new Error("Registrierung am Server fehlgeschlagen");
  return sub;
}

export async function disablePush(token) {
  const sub = await currentSubscription();
  if (!sub) return;
  await fetch(`${API}/app/admin/push/unsubscribe`, { method: "POST", headers: { "Content-Type": "application/json", "X-Admin-Token": token }, body: JSON.stringify({ endpoint: sub.endpoint }) });
  await sub.unsubscribe();
}
